import { useCallback, useState } from 'react';
import { TestIds } from '@ninjacart/nc-nk-web-deps';
import { adUnits, ScriptBound } from '@ninjacart/nc-nk-core';
import { BannerAds } from '@ninjacart/nc-nk-web-deps';
import { KVPair } from '@ninjacart/nc-nk-store';
import { Dimensions } from 'react-native';

const VIDEO_EXPAND_HEIGHT = 240;

export const useAdManager = (
  requestAd: boolean,
  itemKey: string,
  adSizeDefs?: string[],
  adsPreloadData?: KVPair,
  bannerAdKeywords?: string[],
  onAdSizeChange?: (height: number, width: number) => void,
  initializeAdScript = false
) => {
  // console.log('🚀 ~ initializeAdScript:', initializeAdScript);
  const adUnitId = __DEV__
    ? TestIds.ADAPTIVE_BANNER
    : adUnits.homepageActiveAdUnitId || `/23198695442/kisan_app/homepage_active_feed_companion_ad`;
  const [isBannerAdLoadSuccess, setIsBannerAdLoadSuccess] = useState(false);

  // console.log("Got ad unit id => ", adUnits.homepageActiveAdUnitId);

  const handleAdSizeChange = useCallback(
    (adHeight: number, width: number) => {
      // console.log('🚀 ~ adHeight:', adHeight);
      const needsHeight = VIDEO_EXPAND_HEIGHT + adHeight + 8;
      onAdSizeChange?.(requestAd ? needsHeight : 0, width);
      setIsBannerAdLoadSuccess(true);
    },
    [requestAd, onAdSizeChange]
  );

  const renderAd = useCallback(
    (sizes?: [[number, number]]) => {
      if (!requestAd) return null;

      const adScriptLoadCallback = () => {
        if (window?.['googletag']) {
          window['googletag'] = window['googletag'] || { cmd: [] };
          window['googletag'].cmd.push(() => {
            window['googletag'].pubads().enableSingleRequest();
            window['googletag'].enableServices();
            window['googletag'].pubads().enableLazyLoad({
              fetchMarginPercent: -1,
              // renderMarginPercent: 4,
              // mobileScaling: 2,
            });
          });
        }
      };

      return (
        <ScriptBound
          scriptSrc="https://securepubads.g.doubleclick.net/tag/js/gpt.js"
          scriptLoadCallback={adScriptLoadCallback}
        >
          <BannerAds
            deviceWidth={Dimensions.get('window').width}
            itemKey={itemKey}
            unitId={adUnitId}
            adSizeDefs={adSizeDefs ?? ['320x50']}
            adsPreloadData={adsPreloadData}
            bannerAdKeywords={bannerAdKeywords}
            onAdSizeChange={handleAdSizeChange}
            adgebraShow={false}
            screenName={'feed page'}
            webAdSizeDefs={sizes}
          />
        </ScriptBound>
      );
    },
    [requestAd, itemKey, adSizeDefs, adsPreloadData, bannerAdKeywords, handleAdSizeChange]
  );

  return {
    renderAd,
    isBannerAdLoadSuccess,
    setIsBannerAdLoadSuccess,
  };
};
